import { render, staticRenderFns } from "./Test4.vue?vue&type=template&id=5a2eac72&"
import script from "./Test4.vue?vue&type=script&lang=js&"
export * from "./Test4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports